<template>
  <div id="page">
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <b-modal ref="model_ql" title="提示" ok-title="确定" ok-only>
      <p>查询状态异常，请联系银行</p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "BaseQueryAction",
  data() {
    return {
      bankCode: "",
      bankSerialNumber: "",
      errorMsg: "",
      loading: false,
    };
  },
  mounted: function () {
    this.bankSerialNumber = this.$route.query.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    this.bankCode = this.$route.query.bankCode;
    console.log("bankCode:" + this.bankCode);

    this.toOrderList();
  },
  methods: {
    handleOk: function (bvModalEvt) {
      this.$router.go(-1);
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    toOrderList: function (bankSerialObj) {
      if (config.isSczhBank(this.bankCode)) {
        let serialList = this.bankSerialNumber.split("|");
        var obj = {
          bankCode: this.bankCode,
          serialList: serialList,
        };
        
        this.toSichuanZhonghang(obj);
      } else if (config.isQiluBank(this.bankCode)) {
        var applyDetail = this.$route.query.applyDetail;
        console.log('applyDetail', applyDetail)
        this.toQiluBank(applyDetail);
      } else if (config.isShzhnshBank(this.bankCode)) {
        let serialList = this.bankSerialNumber.split("|");
        var obj = {
          bankCode: this.bankCode,
          serialList: serialList,
        };
        
        this.toShzhnshBank(obj);
      } else if (config.isSchtnfBank(this.bankCode)) {
        console.log("四川天府银行");
        let serialList = this.bankSerialNumber.split("|");
        var obj = {
          bankCode: this.bankCode,
          serialList: serialList,
        };
        this.toSchtnfBank(obj);
      } else if (config.isSchmyshBank(this.bankCode)) {
        let serialList = this.bankSerialNumber.split("|");
        var obj = {
          bankCode: this.bankCode,
          serialList: serialList,
        };
        this.toSchmyshBank(obj);
      } else {
        console.log("非四川中行");
        console.log("bankCode:" + this.bankCode);
      }
    },
    toSichuanZhonghang: function (bankSerialObj) {
      console.log("四川中行");
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.replace({
        name: "OrderList_sczh",
        params: {
          bankSerialObj: queryResult,
        },
      });
    },
    toQiluBank: function (bankSerialObj) {
      let newinput=encodeURIComponent(bankSerialObj)
      var that = this;
      var formData = new FormData();
      formData.append("applyDetail", newinput);
      axios({
        method: "post",
        url: config.config_ql.getDecodeData,
        data: formData,
      })
        .then(function (response) {
          // console.log(response)
          //{"checkStatus":"0","merchNo":"01B1","mobileNo":"xx","flowNo":"500000000757468"}
          if (response.status == 200) {
            let data = response.data;
            if (data.checkStatus == "2") {
              that.showQlStateMsg();
              return;
            } else if (data.checkStatus == "0" || data.checkStatus == "1") {
              that.$router.replace({
                name: "OrderList_ql",
                params: {
                  ...data,
                },
              });
            }
          } else {
          }
          let dataRes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showQlStateMsg: function () {
      this.$refs["model_ql"].show();
    },
    toShzhnshBank: function (bankSerialObj) {
      console.log("深圳农商");
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.replace({
        name: "OrderList_shzhnsh",
        params: {
          bankSerialObj: queryResult,
        },
      });
    },
    
    toSchtnfBank: function (bankSerialObj) {
      console.log("四川天府银行");
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.replace({
        name: "OrderList_schtnf",
        params: {
          bankSerialObj: queryResult,
        },
      });
    },
    toSchmyshBank: function (bankSerialObj) {
      console.log("四川绵阳商行");
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.replace({
        name: "OrderList_schmysh",
        params: {
          bankSerialObj: queryResult,
        },
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/base/BaseQueryAction.vue